<template>
  <div class="index-box">
    <van-list
      class="listBoxVan"
      :immediate-check="false"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="listBox">
        <div
          class="listCard"
          v-for="item in dynamic"
          :key="item.index"
          @click="gotoDynamicDetail(item)"
        >
          <div class="card-list__itemone">
            <!-- <div class="active-list__item-location" v-if="item.newsType == 2">
              校友活动
            </div> -->
            <div class="active-list__item-location-y">{{item.typeNameById}}</div>

            <div
              class="headDiagram"
              :style="{ backgroundImage: `url(${item.coverImg})` }"
            />
          </div>
          <div class="card-list__itemtwo">
            <span class="DynamicTitle">{{ item.title }}</span>
            <span class="DynamicDate">{{ item.uploadTime }}</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 母校动态
      dynamic: [],
      page: 1,
      pageSize: 10,
      lastPage: "",
      loading: false,
      finished: false,
    };
  },
  created() {
    this.getDynamic();
  },
  methods: {
    // 获取母校动态
    async getDynamic() {
      const result = await this.$http.get("/amNews/getAmNews", {
        params: {
          currentPage: this.page,
          perPage: this.pageSize,
        },
      });
      console.log("获取母校动态", result.data.list);
      // this.dynamic = result.data.list;

      for (let i = 0; i < result.data.list.length; i++) {
        this.dynamic.push(result.data.list[i]);
      }

      this.lastPage = result.data.lastPage;
    },

    // 懒加载
    onLoad() {
      this.page = this.page + 1;
      this.getDynamic();
      this.loading = false;
      // 数据全部加载完成
      if (this.page >= this.lastPage) {
        this.finished = true;
      }
    },

    gotoDynamicDetail(item) {
      return this.$router.push({
        path: "/dynamicDetails",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  position: relative;
  .listBoxVan {
    position: relative;
    .listBox {
      width: 100vw;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      .listCard {
        display: flex;
        width: 95vw;
        background: #fff;
        border-radius: 0.5rem;
        height: 7rem;
        margin-left: 2.5vw;
        margin-top: 10px;
        .card-list__itemone {
          flex: 1;
          width: 30vw;
          margin: 5px 0 5px 0;
          margin-left: 5px;
          .active-list__item-location {
            position: relative;
            top: -1px;
            left: -1px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 5.03rem;
            height: 1.79rem;
            font-size: 0.95rem;
            color: #ffffff;
            border-top-left-radius: 10px;
            border-bottom-right-radius: 15px;
            background: #00706e;
            background-size: contain;
            z-index: 2;
          }
          .active-list__item-location-y {
            position: relative;
            top: -1px;
            left: -1px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 5.03rem;
            height: 1.79rem;
            font-size: 0.95rem;
            color: #ffffff;
            border-top-left-radius: 8px;
            border-bottom-right-radius: 8px;
            background: #f79d27;
            background-size: contain;
            z-index: 2;
          }

          .headDiagram {
            position: relative;
            width: 100%;
            height: 100%;
            border-radius: 5px;
            top: -1.79rem;
            z-index: 0;
            image-rendering: -webkit-optimize-contrast;
            image-rendering: -moz-crisp-edges;
            image-rendering: -o-crisp-edges;
            // image-rendering: -webkit-crisp-edges;
            background-size: cover;
            // background-position: center;
          }
        }
        .card-list__itemtwo {
          flex: 2;
          margin: 5px 3px 5px 5px;
          display: flex;
          flex-direction: column;
          .DynamicTitle {
            padding: 5px 5px 0 5px;
            font-size: 1rem;
            font-weight: 600;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .DynamicDate {
            position: absolute;
            padding-left: 5px;
            font-size: 0.9rem;
            color: #a0a0a0;
            margin-top: 5rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/Dynamic.vue